export enum FormErrorsConditionOperator {
  Some = "some",
  Every = "every",
  Only = "only",
  Exclude = "exclude"
}
